import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useKeycloak } from '@react-keycloak/web';

export function usePlanCreatePaymentIntent() {
  const { keycloak } = useKeycloak();
  const queryClient = useQueryClient();

  interface IntentData {
    clientSecret: string;
  }

  return useMutation({
    mutationFn: async (): Promise<IntentData> => {

      const response = await fetch(
        `${import.meta.env.VITE_USER_ENGINE_ENDPOINT}/api/v1/bundles/user_bundle/functions/create_payment_intent`,
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${keycloak.token}`
          },
          method: 'POST',
          body: null
        }
      );
      const data = await response.json();

      const { clientSecret } = data?.data;

      return {
        clientSecret: clientSecret
      };
    },
  });
}